export const normalizeStringList = (values: readonly string[]): string[] => {
    const normalizedValues: string[] = [];
    const seenValues = new Set<string>();

    for (const value of values) {
        const normalizedValue = value.trim();
        if (!normalizedValue || seenValues.has(normalizedValue)) {
            continue;
        }

        seenValues.add(normalizedValue);
        normalizedValues.push(normalizedValue);
    }

    return normalizedValues;
};
